import * as types from '../constants';

export function loadSources(
  state,
  scope,
  page,
  source_name,
  ioc_type,
  data_source,
  vendor,
  sort,
) {
  return {
    type: types.LOAD_SOURCES,
    state,
    scope,
    page,
    source_name,
    ioc_type,
    data_source,
    vendor,
    sort,
  };
}

export function loadSourcesIocCounts(
  state,
  scope,
  page,
  source_name,
  ioc_type,
  data_source,
  vendor,
  sort,
) {
  return {
    type: types.LOAD_SOURCES_IOC_COUNTS,
    state,
    scope,
    page,
    source_name,
    ioc_type,
    data_source,
    vendor,
    sort,
  };
}

export function loadSourcesIocCountsAndIsActive(
  state,
  scope,
  page,
  source_name,
  ioc_type,
  data_source,
  vendor,
  sort,
) {
  return {
    type: types.LOAD_SOURCES_IOC_COUNTS_AND_IS_ACTIVE,
    state,
    scope,
    page,
    source_name,
    ioc_type,
    data_source,
    vendor,
    sort,
  };
}

export function loadSource(uuid) {
  return {
    type: types.LOAD_SOURCE,
    uuid,
  };
}

export function createEmptySource(data) {
  return {
    type: types.CREATE_EMPTY_SOURCE,
    data,
  };
}

export function createURLSource(data) {
  return {
    type: types.CREATE_URL_SOURCE,
    data,
  };
}

export function createFileSource(data) {
  return {
    type: types.CREATE_FILE_SOURCE,
    data,
  };
}

export function deleteSource(uuid) {
  return {
    type: types.DELETE_SOURCE,
    uuid,
  };
}

export function changeSourceScope(data) {
  return {
    type: types.CHANGE_SOURCE_SCOPE,
    data,
  };
}

export function activateSource(data) {
  return {
    type: types.ACTIVATE_SOURCE,
    data,
  };
}

export function updateSource(data) {
  return {
    type: types.UPDATE_SOURCE,
    data,
  };
}

export function updateFileSource(data) {
  return {
    type: types.UPDATE_FILE_SOURCE,
    data,
  };
}

export function addIOCJson(data) {
  return {
    type: types.ADD_IOC_JSON,
    data,
  };
}

export function publishSource(data) {
  return {
    type: types.PUBLISH_SOURCE,
    data,
  };
}
